import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { SlicePipe } from "@angular/common";

@Component({
    selector: "app-trending-game",
    templateUrl: "./trending-game.component.html",
    styleUrls: ["./trending-game.component.scss"],
    standalone: true,
    imports: [IonicModule, SlicePipe]
})
export class TrendingGameComponent implements OnInit {
  @Input() gameImg: string;
  @Input() rank: number;
  @Input() info: string;
  @Output() showPopup = new EventEmitter();
  expanded = false;

  constructor() {}

  ngOnInit() {
  }
}
